const state = {};
const getters = {};
const mutations = {};
const actions = {
  removeAll(context) {
    keyList.forEach(key => {
      context.commit(`REMOVE_${key}`);
    });
  }
};

const keyList = [
  "UserRoleList", //角色下拉列表
  "LoginNameList", //登录账号下拉列表
  "LicenseTypeList", //号牌种类下拉列表
  "GroupList", //集团列表
  "SchoolList", //驾校列表
  "VehicleTypeList", //车辆类别
  "ChargeTypeList", //收费类型列表
  "PersonTypeList", //人员类型列表
  "DeviceTypeList", //设备类型列表
  "DrivingTypeList", //驾驶证类型列表
  "SubitemTypeTwoList", //科目二项目列表
  "GroupTreeList", //集团树列表
  "TeamList", //中队列表
  "VehicleModelSettingList", //车模列表
  "ResourceTypeList",
  "ResourceTypeKeyPrefixList",
  "FileTypeList",
  "VehicleModelDropdownList", //车模列表(code,name)
  "VehicleModelAndVehicleDropdownList", //车模列表(code,name)
  "OBDList", //OBD取反
  "EmulatorAppointmentStatusList" //模拟器预约状态
];

const create = key => {
  state[key] = null;
  getters[key] = state => {
    return state[key] || JSON.parse(sessionStorage.getItem(key));
  };
  mutations[`SAVE_${key}`] = (state, value) => {
    state[key] = value;
    sessionStorage.setItem(key, JSON.stringify(value));
  };
  mutations[`REMOVE_${key}`] = state => {
    sessionStorage.removeItem(key);
    state[key] = null;
  };
  actions[`save${key}`] = (context, value) => {
    context.commit(`SAVE_${key}`, value);
  };
  actions[`remove${key}`] = context => {
    context.commit(`REMOVE_${key}`);
  };
};

keyList.forEach(key => {
  create(key);
});

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/js/store/modules/dropDown.js